import { z } from "zod";

export const memberTagsSortSchema = z.enum([
  "name asc",
  "name desc",
  "tagged_members_count asc",
  "tagged_members_count desc",
]);

export const memberTagsSearchSchema = z.object({
  page: z.coerce.number<number>().int().positive().optional().catch(1),
  q: z
    .object({
      name_i_cont: z.string().trim().optional().catch(undefined),
      s: memberTagsSortSchema.optional().catch(undefined),
    })
    .optional()
    .catch(undefined),
});

export type MemberTagsQuery = NonNullable<
  z.infer<typeof memberTagsSearchSchema>["q"]
>;
